<template>
  <nav id="menu" class="menu" :class="{ menu_active: isMenu }">
    <div class="logo">
      <router-link to="/"
        ><img src="@/assets/images/logo.png" alt="Logo Image"
      /></router-link>
    </div>

    <div class="menu_mobile" :class="{ 'menu-opened': isMenu }">
      <div class="burger-position">
        <div class="burger-container" @click="onClick">
          <div id="burger">
            <div class="bar topBar"></div>
            <div class="bar btmBar"></div>
          </div>
        </div>
      </div>
      <ul class="menu" @click="onClick">
        <li class="menu-item" @click="goLink('/portfolio')">포트폴리오</li>
        <li class="menu-item" @click="goLink('/solution')">솔루션</li>
        <li class="menu-item" @click="goLink('/price')">견적</li>
        <li class="menu-item" @click="goLink('/tech')">Tech</li>
        <li class="menu-item" @click="goLink('/about')">About Us</li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderMobile",
  data: () => ({
    isMenu: false,
  }),
  computed: {},
  async mounted() {},
  methods: {
    onClick() {
      this.isMenu = !this.isMenu;
      if (this.isMenu) {
        document.querySelector("html").style.overflowY = "hidden";
      } else {
        document.querySelector("html").style.overflowY = "auto";
      }
    },
    goLink(path) {
      this.isMenu = false;
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="scss">
$md-device: 1440px;
$m_menu_size: 54px;

@mixin md {
  @media (max-width: $md-device) {
    @content;
  }
}

.logo {
  position: absolute;
  display: block;
  left: 20px;
  top: 15px;
  z-index: 100;
}
.logo img {
  max-width: 140px;
}

#menu {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #ffffff;

  height: 80px;
  padding: 0 60px;
  z-index: 9999;
  @include md {
    display: flex;
    height: $m_menu_size;
    padding: 0;
    transition: all 0.3s ease-out, background 0.1s ease-out;
    // transition-delay: 0.8s;
    &.menu_active {
      height: 100%;
      background-color: #fff;
      transition: all 0.3s ease-in, background 0.1s ease-in;
      z-index: 99999;
      // transition-delay: 0.25s;
    }
  }
  .menu_wrap {
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    overflow: hidden;
    @include md {
      display: none;
    }
    .bg {
      position: absolute;
      top: -68px;
      left: -1px;
      width: 400px;
      .svg_door {
        height: 190px;
      }
    }
  }
  .main_menu {
    display: flex;
    flex: 1;
    // justify-content: space-evenly;
    justify-content: flex-end;
    list-style: none;
    // margin: 0 100px;
    li {
      margin: 0 25px;
      @media (max-width: 1200px) {
        margin: 0 10px;
      }
      @media (max-width: 1100px) {
        margin: 0;
      }
    }

    @include md {
      margin: 0 30px;
    }
  }
}

.menu_mobile {
  display: block;
  width: 100%;
  height: 54px;
  background: #fff;
  position: relative;
  transition: all 0.5s ease-out, background 1s ease-out;
  transition-delay: 0.2s;

  .burger-position {
    position: absolute;
    right: 0;
    top: 0;
  }
  .burger-container {
    position: relative;
    display: inline-block;
    height: $m_menu_size;
    width: $m_menu_size;
    cursor: pointer;
    transform: rotate(0deg);
    transition: all 0.3s cubic-bezier(0.4, 0.01, 0.165, 0.99);
    #burger {
      width: 18px;
      height: 8px;
      position: relative;
      display: block;
      margin: -4px auto 0;
      top: 50%;
      .bar {
        cursor: pointer;
        width: 100%;
        height: 1px;
        display: block;
        position: relative;
        background: #000;
        transition: all 0.3s cubic-bezier(0.4, 0.01, 0.165, 0.99);
        transition-delay: 0s;
        &.topBar {
          transform: translateY(0px) rotate(0deg);
        }
        &.btmBar {
          transform: translateY(6px) rotate(0deg);
        }
      }
    }
  }
  ul.menu {
    position: relative;
    padding: 58px 48px 0;
    list-style: none;
    z-index: -1;
    visibility: hidden;
    display: flex;
    flex-direction: column;
    height: calc(100% - 100px);

    .bottom-item {
      margin-top: auto !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: 0 !important;
      button.m_login {
        height: 44px !important;
        padding: 0 20px !important;
        margin: 0;
        &::before {
          display: none;
        }
      }
      .bottom-item-list {
        display: flex;
        justify-content: center;
        button {
          height: 44px !important;
          padding: 0 10px !important;
          margin: 0 10px;
        }
      }
    }

    .menu-item {
      border-bottom: 1px solid #333;
      margin-top: 5px;
      transform: scale(1.15) translateY(-30px);
      opacity: 0;
      transition: transform 0.5s cubic-bezier(0.4, 0.01, 0.165, 0.99),
        opacity 0.6s cubic-bezier(0.4, 0.01, 0.165, 0.99);
      color: #333;
      font-size: 16px;
      line-height: 2.8em;
      &:nth-child(1) {
        transition-delay: 0.22s;
      }
      &:nth-child(2) {
        transition-delay: 0.15s;
      }
      &:nth-child(3) {
        transition-delay: 0.08s;
      }
      &:nth-child(4) {
        transition-delay: 0.01s;
      }
      &:nth-child(5) {
        transition-delay: 0.01s;
      }
      &:nth-child(6) {
        transition-delay: 0.01s;
      }
    }
  }
  &.menu-opened {
    height: 100%;
    background-color: #fff;
    transition: all 0.3s ease-in, background 0.5s ease-in;
    transition-delay: 0.25s;
    .burger-container {
      transform: rotate(90deg);
      z-index: 1;
      #burger {
        .bar {
          transition: all 0.4s cubic-bezier(0.4, 0.01, 0.165, 0.99);
          transition-delay: 0.2s;
          &.topBar {
            transform: translateY(4px) rotate(45deg);
          }
          &.btmBar {
            transform: translateY(3px) rotate(-45deg);
          }
        }
      }
    }
    ul.menu {
      display: flex;
      visibility: visible;
      z-index: 999;
      li.menu-item {
        transform: scale(1) translateY(0px);
        opacity: 1;
        &:nth-child(1) {
          transition-delay: 0.27s;
        }
        &:nth-child(2) {
          transition-delay: 0.34s;
        }
        &:nth-child(3) {
          transition-delay: 0.41s;
        }
        &:nth-child(4) {
          transition-delay: 0.48s;
        }
        &:nth-child(5) {
          transition-delay: 0.55s;
        }
        &:nth-child(6) {
          transition-delay: 0.62s;
        }
      }
    }
  }
}
</style>